import { gql } from '__generated__';

export default gql(`
  mutation DeleteDiscount($id: ID!) {
    deleteDiscount(id: $id)
  }
`);
